import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "app-fullscreen-loader",
  templateUrl: "./fullscreen-loader.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./fullscreen-loader.component.scss"]
})
export class FullscreenLoaderComponent {
  @Input() deviceId = "";
  @Input() current = 0;
  @Input() max = 0;

  get progressPercent(): number {
    if (this.max <= 0) {
      return 0;
    }

    const percent = (this.current / this.max) * 100;
    return Math.min(Math.max(percent, 0), 100);
  }
}
